module.exports = __webpack_public_path__ + "img/scales-no.f303c65e.svg";